<template>
  <div>
    <p>
      These are the remaining geometric parameters that define the
      constellation. They are computed from the other constellation inputs
      according to the respective definition type, such as 'Walker-Delta',
      'Global Streets of Coverage', etc. (see the 'constellation definition
      type' tooltip for more information).
    </p>
    <p>
      These implicit parameters can be used to reproduce the current
      constellation with the 'Custom' definition type.
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationGeometryImplicitParameters'
}
</script>
